import React from 'react';
import { useTranslation } from 'react-i18next';
import ClientListForm from './Components/ClientListForm';

const ClientList = () => {
  const { t } = useTranslation();

  return (
    <div className="l-wrap-xl">
      <h1>{t('features.ClientCustomFeatures.ClientList.client_list')}</h1>
      <ClientListForm />
    </div>
  );
};

export default ClientList;
